import Captions from "@/views/Captions.vue";
import AddCreditCard from "@/views/AddCreditCard.vue";
import PaymentMethods from "@/views/PaymentMethods.vue";
import CreditCards from "@/views/CreditCards.vue";
import AddBalance from "@/views/AddBalance.vue";
import PixPendingPayment from "@/views/PixPendingPayment.vue"
import { Component } from "vue";


export interface IOffcanvasPage {
    key: string
    title: string
    props?: any
    component: Component
}

export enum EOffcanvasPage {
    map_captions = 'map_captions',
    add_card = 'add_card',
    payment_methods = 'payment_methods',
    credit_cards = 'credit_cards',
    add_balance = 'add_balance',
    pix_pending_payment = 'pix_pending_payment',
}

type OffCanvasPageMap = {
    [K in EOffcanvasPage]: IOffcanvasPage
}

export const OffCanvasPages: OffCanvasPageMap = {
    [EOffcanvasPage.map_captions]: {
        key: EOffcanvasPage.map_captions,
        title: "",
        component: Captions,
    },
    [EOffcanvasPage.payment_methods]: {
        key: EOffcanvasPage.payment_methods,
        title: "Métodos de pagamento",
        component: PaymentMethods,
    },
    [EOffcanvasPage.add_card]: {
        key: EOffcanvasPage.add_card,
        title: "Adicionar cartão",
        component: AddCreditCard
    },
    [EOffcanvasPage.credit_cards]: {
        key: EOffcanvasPage.credit_cards,
        title: "Cartões cadastrados",
        component: CreditCards
    },
    [EOffcanvasPage.add_balance]: {
        key: EOffcanvasPage.add_balance,
        title: "Adicionar saldo",
        component: AddBalance
    },
    [EOffcanvasPage.pix_pending_payment]: {
        key: EOffcanvasPage.pix_pending_payment,
        title: "Adicionar saldo",
        component: PixPendingPayment
    },
}
